import React from "react";
import SyncIcon from "@mui/icons-material/Sync";
import FlowActionButton from "@components/FlowActionButtons/FlowActionButton";

interface ResubmitButtonProps {
  langBase: string;
  permission: string;
  isActionAvailable: boolean;
  onUpdate: () => void;
  variant?: "text" | "outlined" | "contained";
}

const ResubmitButton: React.FC<ResubmitButtonProps> = ({
  langBase,
  permission,
  isActionAvailable,
  onUpdate,
  variant = "outlined",
}) => {
  return (
    <FlowActionButton
      langBase={langBase}
      permission={permission}
      isActionAvailable={isActionAvailable}
      labelKey="resubmit-button"
      testId="resubmit"
      variant={variant}
      startIcon={<SyncIcon />}
      onClick={onUpdate}
    />
  );
};
export default ResubmitButton;
